<template>
	<div class="ChatTopBar">


		<div class="ChatTopBarLeft">
			<ul>
				<li class="backBtn" @click="goBack()">
					<img src="../../assets/icon/next-arrow.png" alt="go back">
				</li>
				<li class="ChatTopBarUserDesc">
					<img alt="commaful-logo" src="../../assets/images/chat-user1.png" />
					<div class="TopBarUserDes">
						<h3>Highzone AF</h3>
						<p>Last seen 11.43 AM</p>
					</div>
				</li>
			</ul>
		</div>


		<div class="ChatTopBarRight">
			<block-unblock :icon="`menu.svg`"></block-unblock>
		</div>


	</div>
</template>


<script>
  export default {

      name: "direct-chat-topbar",

      data() {
          return {

          }
      },

      methods: {
      	goBack(){
      		return this.$router.push('/inbox');
      	}
      },


  }
</script>



<style>

	@import '../../assets/css/chat-top-bar.css';

</style>